export const objGenericUrl = {
    personaSolicitud:
        '/personas/{0}/solicitudes/{1}/persona-solicitud/codeudores/',
    personaSolicitudReferecias:
        '/personas/{0}/solicitudes/{1}/persona-solicitud/referenciados/',
};
